import * as React from "react";
import Typography from "@mui/material/Typography";

export default function Footer(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="right" {...props}>
      {"© GO Inc."}
    </Typography>
  );
}
